const getters = {
  componentArray: ({ componentList }) => Object.values(componentList),
  componentNameArray: ({ componentList }) => Object.keys(componentList).map(key => componentList[key].name),
  componentList: ({ componentList }) => componentList,
  newComponent: ({ newComponent }) => newComponent
}

export default getters
